// src/Lexpromt/services/promptService.js
import {
    db,
    collection,
    addDoc,
    doc,
    getDoc,
    setDoc,
    onSnapshot,
    query,
    orderBy,
    where,
  } from "../firebaseConfig";
  
  const PROMPTS_COLLECTION = "prompts";
  
  // Create a new prompt document
  export async function createPrompt(data) {
    // data: { title, body, department, visibility, ownerId, createdAt, resultMedia, embeddedUrls, collaboratorAvatars }
    const colRef = collection(db, PROMPTS_COLLECTION);
    const docRef = await addDoc(colRef, data);
    return docRef.id;
  }
  
  // Fetch a single prompt by ID
  export async function getPromptById(promptId) {
    const docRef = doc(db, PROMPTS_COLLECTION, promptId);
    const snapshot = await getDoc(docRef);
    return snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null;
  }
  
  // Real‐time listener for all prompts, with optional department filter
  export function subscribeToPrompts(callback, departmentFilter = "All") {
    let q;
    if (departmentFilter && departmentFilter !== "All") {
      q = query(
        collection(db, PROMPTS_COLLECTION),
        where("department", "==", departmentFilter),
        orderBy("createdAt", "desc")
      );
    } else {
      q = query(
        collection(db, PROMPTS_COLLECTION),
        orderBy("createdAt", "desc")
      );
    }
  
    return onSnapshot(q, (querySnapshot) => {
      const list = [];
      querySnapshot.forEach((docSnap) => {
        list.push({ id: docSnap.id, ...docSnap.data() });
      });
      callback(list);
    });
  }
  
  // Update an existing prompt (merge fields)
  export async function updatePrompt(promptId, data) {
    const docRef = doc(db, PROMPTS_COLLECTION, promptId);
    await setDoc(docRef, data, { merge: true });
  }
  